import { render } from "./List.vue?vue&type=template&id=8e848340&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=8e848340&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8e848340"

export default script